import {
    CLEAR_FOLLOW_UPS,
    GET_FOLLOW_UP,
    GET_FOLLOW_UPS,
    SET_FOLLOW_UP_PAGINATION,
    SET_LOADING,
} from '../types'

const FollowUpReducer = (state, action) => {

    switch (action.type) {

        case GET_FOLLOW_UPS:
            return {
                ...state,
                followUps: action.payload,
                loading: false
            }

        case GET_FOLLOW_UP:
            return {
                ...state,
                followUp: action.payload,
                loading: false
            }

        case SET_FOLLOW_UP_PAGINATION:
            return {
                ...state,
                followUpPagination: action.payload,
                loading: false
            }

        case CLEAR_FOLLOW_UPS:
            return {
                ...state,
                followUps: [],
                loading: false
            }

        case SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state
    }

}

export default FollowUpReducer
